import React, { useMemo } from 'react';
import Combobox from './ui/Combobox';
import { IconSearch } from './ui/icons';

// `inputProps` is spread onto the search field last, so a caller can name the
// field for its own context (placeholder, aria-label) or mark it with
// `data-drawer-autofocus` when the picker is the first thing a dialog asks for.
// Shows nothing until somebody types, then lists the people who match.
function UserPicker({ users = [], excludeIds = [], onSelect, inputProps = {} }) {
  const { 'aria-label': ariaLabel, placeholder = 'Add crew member...', ...inputRest } = inputProps;

  // "Austin Mur" is how people type a name; the whole name is the label so neither half alone has to hold it.
  const options = useMemo(
    () => users
      .filter((u) => !excludeIds.includes(u.id))
      .map((u) => ({ id: u.id, label: `${u.firstname || ''} ${u.lastname || ''}`.trim(), data: u })),
    [users, excludeIds]
  );

  return (
    <Combobox
      label={ariaLabel || 'Add crew member'}
      options={options}
      value={null}
      onSelect={(o) => { if (o) onSelect(o.data); }}
      minQuery={1}
      openOnFocus={false}
      chevron={false}
      leading={<IconSearch className="h-3.5 w-3.5" />}
      emptyMessage="No matching users"
      noOptionsMessage="No matching users"
      placeholder={placeholder}
      {...inputRest}
    />
  );
}

export default UserPicker;
